import React from 'react';
import {
  TextInput,
  Filter,
  DateInput,
} from 'react-admin';

export const BillFilter = (props) => (
  <Filter filters={billFilters} {...props} />
);

export const billFilters = [
  <TextInput source="code" label="Search by code" alwaysOn />,
  <DateInput source='startDate' label="from" alwaysOn />,
  <DateInput source='endDate' label="to" alwaysOn />,
];
